export const SAVE_CARD_DISCLAIMER = 'saveCardDisclaimer';
